export const ART_EDITING_AREA_SELECTORS = [
	'.cdk-overlay-container',
	'rx-intuitive-art-teeth-diagram',
	'rx-intuitive-art-treatment-buttons',
	'rx-intuitive-art-treatment-viewlist',
	'[rx-intuitive-teeth-diagram-footer] button',
	'[rx-intuitive-teeth-diagram-banner]'
] as const;
